import React, { useState, useCallback, useEffect } from "react";
import SearchGarageList from "./components/garage_list/SearchGarageList";
import Map from "./components/map/map";
import { states } from './constants/constants';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { changeMetricUnit } from './services/redux/actions';
import { useGeolocated } from "react-geolocated";
import { getDirectionFromPoint, getPointsFromDirection } from './services/mapbox/mapboxServices';
import axios from "axios";
import * as turf from '@turf/turf';
import Metatags from "../Metatags/Metatags";

const feetSelector = createSelector(
    state => state.feets,
    feets => feets
);

function GarageSearch() {
    const elementOptions = states.map((item, index) => {
        return (
            <option value={item.value} key={index}> {item.info} </option>
        );
    });

    const props = useGeolocated({
        positionOptions: {
            enableHighAccuracy: false
        },
        userDecisionTimeout: 5000
    })

    useEffect(() => {
        if (props.coords) {
            setCurrentLocation(() => ({
                longitude: props.coords.longitude,
                latitude: props.coords.latitude
            }));
        } else {
            //	actionForMap({ lng: defaultLongitude, lat: defaultLatitude });
        }
    }, [props.coords]);



    const feets = useSelector(feetSelector);
    const dispatch = useDispatch();

    function handleFeetConverterButton() {
        const reduxAction = changeMetricUnit(!feets);
        dispatch(reduxAction);
    }

    const [showResults, setShowResults] = useState(false);
    const [garagesLocations, setGaragesLocations] = useState(null);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [radiusmy, setRadius] = useState(20);

    const user = useSelector(state => state.user.uid);

    const [garagesList, setGaragesList] = useState();
    const [circle, setCircle] = useState(null);
    const [inputFields, setInputFields] = useState({
        state: "",
        city: "",
        neighborhood: "",
        zipcode: "",
        minarea: "",
        maxarea: ""
    });

    const handleChange = (e) => {
        console.log(e)
        setInputFields({ ...inputFields, [e.target.name]: e.target.value });
    };

    const ClearSearchField = () => {
        setInputFields({
            state: "",
            city: "",
            neighborhood: "",
            zipcode: "",
            minarea: "",
            maxarea: ""
        })
    }

    async function handleSubmit(event) {
        event.preventDefault();
        try {

            const cors = await getPointsFromDirection({ state: inputFields.state, city: inputFields.city, zipcode: inputFields.zipcode })
            console.log('corscors', { state: inputFields.state, city: inputFields.city, zipcode: inputFields.zipcode })
            setCurrentLocation({ latitude: cors['latitude'], longitude: cors['longitude'] })

            let arrayForFiltering = [];
            const formData = new FormData();
            formData.append('action', 'SearchGarage');

            if (inputFields.minarea > 0) arrayForFiltering = [...arrayForFiltering, [
                formData.append('minArea', inputFields.minarea)
            ]];

            if (inputFields.maxarea > 0) arrayForFiltering = [...arrayForFiltering, [
                formData.append('maxArea', inputFields.maxarea)
            ]];
            // if (inputFields.state !== '' && inputFields.city !== '' && inputFields.zipcode !== '') {
            //     formData.append('lat', cors.lat);
            //     formData.append('lon', cors.lng);
            //     formData.append('radius', radiusmy);
            // } else {
            if (inputFields.state !== '') arrayForFiltering = [...arrayForFiltering, [
                formData.append('state', inputFields.state?.toLowerCase())
            ]];

            if (inputFields.city !== '') arrayForFiltering = [...arrayForFiltering, [
                formData.append('city', inputFields.city?.toLowerCase())
            ]];

            if (inputFields.zipcode !== '') arrayForFiltering = [...arrayForFiltering, [
                formData.append('zipcode', inputFields.zipcode)
            ]];

            if (inputFields.neighborhood !== '') arrayForFiltering = [...arrayForFiltering, [
                formData.append('neighborhood', inputFields.neighborhood?.toLowerCase())
            ]];

            // }

            console.log('formData', formData);

            const responseZipCode = await axios.post(`${process.env.REACT_APP_API_URL}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            const garagesLocations = responseZipCode.data.data;
            let garagesLocationsObject = {}
            garagesLocations.forEach(item => {
                if (item) {
                    const garagePicture = item.garagePictures ? item.garagePictures : '';
                    garagesLocationsObject = {
                        ...garagesLocationsObject,
                        [item.id]: {
                            PageLink: item.id,
                            coordinates: { 'latitude': item.lat, 'longitude': item.lon },
                            // address: `${(user !== "none" && user !== "") ? item.address : 'Area : ' + item.area}`,
                            address: `${(user !== "none" && user !== "") ? item.address : ''}`,
                            secondLine: `${'<b>Area :</b> ' + item.area + ', <b>DOOR TYPE :</b> '
                                + (item.isConnectedToHouse == "true" ? 'Connected to the House | ' : '')
                                + (item.doorOpener == "true" ? 'Door Opener | ' : '')
                                + (item.drywalled == "true" ? 'Drywalled | ' : '')
                                + (item.otherStorage == "true" ? 'Other Storage | ' : '')
                                + (item.sideDoor == "true" ? 'Side Door | ' : '')
                                + (item.windows == "true" ? 'Windows' : '')
                                }`,
                            imageUrl: process.env.REACT_APP_UPLOAD_URL + garagePicture[0]
                        }
                    };
                }
            })

            console.log('garagePicture', garagesLocations)
            if (garagesLocations && Object.keys(garagesLocations).length > 0) {
                setGaragesList(() => ({ ...garagesLocations }));
            } else {
                // alert(data.city)
                setGaragesList(() => ({}));
            }
            setShowResults(() => true);
            setGaragesLocations(garagesLocationsObject)




        } catch (err) {
            throw err;
        }
    };




    const bringGaragesLoactions = useCallback(async (coors, _place) => {

        var center = [coors.lng, coors.lat];
        var radius = radiusmy;
        var options = { steps: 10, units: 'kilometers' };
        var turff = turf.circle(center, radius, options);
        setCircle(turff)
        console.log('center', center)

        try {


            const formData = new FormData();
            formData.append('action', 'AutoSearchGarage');
            formData.append('lat', coors.lat);
            formData.append('lon', coors.lng);
            formData.append('radius', radiusmy);


            const responseZipCode = await axios.post(`${process.env.REACT_APP_API_URL}`, formData);
            const garagesLocations = responseZipCode.data.data;
            let garagesLocationsObject = {}
            garagesLocations.forEach(item => {
                if (item) {
                    const garagePicture = item.garagePictures ? item.garagePictures : '';
                    garagesLocationsObject = {
                        ...garagesLocationsObject,
                        [item.id]: {
                            PageLink: item.id,
                            coordinates: { 'latitude': item.lat, 'longitude': item.lon },
                            address: `${(user !== "none" && user !== "") ? item.address : 'Area : ' + item.area}`,
                            imageUrl: process.env.REACT_APP_UPLOAD_URL + garagePicture[0]
                        }
                    };
                }
            })
            return garagesLocationsObject;
        }
        catch (err) {
            console.log(err);
        }


    }, []);


    const mapAction = useCallback(async (newLngLt) => {
        try {
            //   console.log('newLngLt',newLngLt);
            setCurrentLocation({ latitude: newLngLt['lat'], longitude: newLngLt['lng'] })

            const place = await getDirectionFromPoint(newLngLt);
            setInputFields((prev) => {
                const updatedFields = {
                    ...prev,
                    state: place.state ? place.state : prev.state ? prev.state : '',
                    city: place.city ? place.city : prev.city ? prev.city : '',
                    neighborhood: place.neighborhood ? place.neighborhood : prev.neighborhood ? prev.neighborhood : '',
                    zipcode: place.zipcode ? place.zipcode : prev.zipcode ? prev.zipcode : '',
                };

                bringGaragesLoactions(newLngLt).then(resp => {
                    console.log('resp', resp)
                    setGaragesLocations(() => resp ? resp : {});
                });

                return updatedFields;
            });
        } catch (err) {
            throw err;
        }
    }, []);

    return (
        <>
            <Metatags
                title="Garage Storage Here"
                description="Store your stuff in a garage"
                keywords="rent garage space,secure garage"
            />
            <section className="page-content sec-padding half-map pt-0">
                <div className="container-full">
                    <div className="page-content-details">
                        <div className="row m-0">
                            <div className="col-xl-6 pl-0 ps-0 half-mpy">
                                {/* <div id="map-container" className="fullwidth-home-map">
                                <div id="map" data-map-zoom="9"></div> 
                            </div>*/}
                                <Map
                                    type='multiple_pointers'
                                    action={mapAction}
                                    elementStylePosition='fixed'
                                    geoLocation={currentLocation}
                                    garagesOnMap={garagesLocations}
                                    extraInfo={JSON.stringify(circle)}
                                    addClass="search-div"
                                />
                            </div>
                            <div className="col-xl-6 pl-0 ps-0 half-wd order--1">
                                <div className="widget-search-properties">
                                    {!showResults && (
                                        <>
                                            <div className="sec-title row pb-2">
                                                <h3 className="col-md-6 text-start">Search Garage</h3>
                                                <div className="col-md-6 text-end">
                                                    <button className="btn btn-secondary me-2" onClick={ClearSearchField}>Clear Search</button>
                                                    <button className="btn btn-primary" onClick={handleFeetConverterButton}>{`Change to ${feets ? 'meter' : 'feet'}`}</button>

                                                </div>
                                            </div>
                                            <form onSubmit={handleSubmit}>
                                                <div className="form-group row">
                                                    <label className="form-label  col-md-4" htmlFor="state"> State:</label>
                                                    <div className="col-md-8">
                                                        <select name="state" type="text" className="form-select" value={inputFields.state} onChange={handleChange} >
                                                            <option>All States</option>
                                                            {elementOptions} </select>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="form-label  col-md-4" htmlFor="city"> City:</label>
                                                    <div className="col-md-8"><input name="city" type="text" className="form-control" value={inputFields.city} onChange={handleChange} />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="form-label  col-md-4" htmlFor="neighborhood"> Neighborhood:</label>
                                                    <div className="col-md-8"><input name="neighborhood" type="text" className="form-control" value={inputFields.neighborhood} onChange={handleChange} />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="form-label  col-md-4" htmlFor="zipcode"> Zip Code:</label>
                                                    <div className="col-md-8"><input name="zipcode" type="text" className="form-control" value={inputFields.zipcode} onChange={handleChange} />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="form-label  col-md-4" htmlFor="minarea"> Min Area {feets ? 'ft' : 'm'}:</label>
                                                    <div className="col-md-8"><input name="minarea" type="text" className="form-control" value={inputFields.minarea} onChange={handleChange} />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="form-label  col-md-4" htmlFor="maxarea"> Max Area {feets ? 'ft' : 'm'}:</label>
                                                    <div className="col-md-8"><input name="maxarea" type="text" className="form-control" value={inputFields.maxarea} onChange={handleChange} />
                                                    </div>
                                                </div>
                                                <input type="submit" className="btn btn-primary btn-lg" />
                                            </form>
                                        </>
                                    )}
                                    {showResults && (

                                        <div className="listing-sec">
                                            <div className="sec-title row pb-2">
                                                <div className="col-md-6 text-start">
                                                    <h3>RESULTS</h3>
                                                </div>
                                                <div className="col-md-6 text-end">
                                                    <button className="btn btn-primary" onClick={() => setShowResults(() => false)}>Search</button>
                                                </div>
                                            </div>

                                            <div className="tab-content">
                                                <div className="tab-pane fade show active" id="vertical-post" role="tabpanel" aria-labelledby="vertical-tab">
                                                    <div className="sales-items">
                                                        <SearchGarageList
                                                            garagesList={garagesList}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}
export default GarageSearch; 